import React, {FC} from "react"

import {StyledPara} from "./styled/Header"

interface RenderProps {
  showText: string
}

interface Props {
  renderProps: RenderProps
}

const AccordionHeader: FC<Props> = ({renderProps: {showText}}) => (
  <StyledPara large bold>
    {showText}
  </StyledPara>
)

export default AccordionHeader
